import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", null, [
        _createElementVNode("td", {
            title: _ctx.item.name,
            class: "ta-s td__worker-name"
        }, _toDisplayString(_ctx.item.name), 9 /* TEXT, PROPS */, _hoisted_1),
        _createElementVNode("td", {
            title: _ctx.item.code,
            class: "ta-s"
        }, _toDisplayString(_ctx.item.code), 9 /* TEXT, PROPS */, _hoisted_2),
        _createElementVNode("td", {
            title: _ctx.item.hubEmployeeNumber,
            class: "ta-s"
        }, _toDisplayString(_ctx.item.hubEmployeeNumber), 9 /* TEXT, PROPS */, _hoisted_3)
    ]));
}
